import * as abi from 'web3-eth-abi';
import { METHODS } from './constants';
let idCount = 0;
// @ts-ignore
const web3abiDecoder = abi.default;
export function decodeResult(method, result) {
    const rpcResult = result.result;
    return rpcResult === '0x'
        ? null
        : web3abiDecoder.decodeParameter(METHODS[method].returnEncoding, rpcResult);
}
export function constructJSONRPC(address, method, methodParam) {
    const data = methodParam
        ? METHODS[method].sig + methodParam.replace('0x', '')
        : METHODS[method].sig;
    idCount += 1;
    return {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [
            {
                to: address,
                gas: METHODS[method].gas,
                gasPrice: METHODS[method].gasPrice,
                value: METHODS[method].value,
                data,
            },
        ],
        id: idCount,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXItd3JhcHBlci11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvcHJvdmlkZXItd3JhcHBlci11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssR0FBRyxNQUFNLGNBQWMsQ0FBQztBQUdwQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBRXRDLElBQUksT0FBTyxHQUFHLENBQUMsQ0FBQztBQUNoQixhQUFhO0FBQ2IsTUFBTSxjQUFjLEdBQUcsR0FBRyxDQUFDLE9BQU8sQ0FBQztBQUVuQyxNQUFNLFVBQVUsWUFBWSxDQUFDLE1BQWMsRUFBRSxNQUFNO0lBQ2pELE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7SUFDaEMsT0FBTyxTQUFTLEtBQUssSUFBSTtRQUN2QixDQUFDLENBQUMsSUFBSTtRQUNOLENBQUMsQ0FBQyxjQUFjLENBQUMsZUFBZSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxjQUFjLEVBQUUsU0FBUyxDQUFDLENBQUM7QUFDaEYsQ0FBQztBQUVELE1BQU0sVUFBVSxnQkFBZ0IsQ0FDOUIsT0FBZSxFQUNmLE1BQWMsRUFDZCxXQUFvQjtJQUVwQixNQUFNLElBQUksR0FBRyxXQUFXO1FBQ3RCLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxHQUFHLFdBQVcsQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQztRQUNyRCxDQUFDLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsQ0FBQztJQUV4QixPQUFPLElBQUksQ0FBQyxDQUFDO0lBRWIsT0FBTztRQUNMLE9BQU8sRUFBRSxLQUFLO1FBQ2QsTUFBTSxFQUFFLFVBQVU7UUFDbEIsTUFBTSxFQUFFO1lBQ047Z0JBQ0UsRUFBRSxFQUFFLE9BQU87Z0JBQ1gsR0FBRyxFQUFFLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxHQUFHO2dCQUN4QixRQUFRLEVBQUUsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLFFBQVE7Z0JBQ2xDLEtBQUssRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsS0FBSztnQkFDNUIsSUFBSTthQUNMO1NBQ0Y7UUFDRCxFQUFFLEVBQUUsT0FBTztLQUNaLENBQUM7QUFDSixDQUFDIn0=